'use es6';

import makeAsyncLoader from './makeAsyncLoader';
const AsyncImageEditor = makeAsyncLoader(() => import( /* webpackChunkName: "image-editor" */'FileManagerCore/components/ImageEditor').then(module => module.default).catch(err => {
  throw err;
}));
export default AsyncImageEditor;